import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
//import Dropzone from 'react-dropzone';
import { Button, Typography, TextareaAutosize, TextField, FormControl, MenuItem,
         Popover, Select, InputLabel, Dialog, DialogContent } from '@mui/material';
import { Help } from '@mui/icons-material';
import styled from 'styled-components';

import Header from './Header';
import { exampleData } from './FlowStore';

// const getColor = (props) => {
//   if (props.isDragAccept) {
//     return 'rgb(0,255,0,.2)';
//   }
//   if (props.isDragReject) {
//     return 'rgb(255,0,0,.2)';
//   }
//   if (props.isDragActive) {
//     return 'rgb(0,255,0,.2)';
//   }
//   return 'whitesmoke';
// }

// const StyledDropDiv = styled.div`
//   height: 100px;
//   border-radius: 5px;
//   margin-top: 20px;
//   border-width: 1px;
//   border-style: dashed;
//   background-color: ${props => getColor(props)};
// `;

const ResultDiv = styled.div`
  width: 100%;
  height: 100%;
  margin-right: 2em;
  margin-left: 2em;
  border: 1px black solid;
  overflow-y: auto;
`;

const StyledInputLabel = styled(InputLabel)`
  background-color: white;
  padding-left: 2;
  padding-right: 2;
`;

const TemplateAdmin = observer((props) => {
  const store = props.store;
  //const [uploadErrorOpen, setUploadErrorOpen] = React.useState(false);
  //const [uploadErrorMessage, setUploadErrorMessage] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [helpOpen, setHelpOpen] = React.useState(false);
  const [testDataOpen, setTestDataOpen] = React.useState(false);

  // const showFailDialog = errorType => {
  //   console.log(errorType);
  //   let msg = "Error uploading file";
  //   if (errorType === 'file_reading_error')
  //     msg = "Please try again with a single PDF";
  //   else if (errorType === 'upload_disabled')
  //     msg  = "File uploading not enabled in Demo version.  Please select a pre-loaded document to work on, below.";
  //   setUploadErrorOpen(true);
  //   setUploadErrorMessage(msg);
  // };

  // const onDropPTO = (acceptedFiles, rejectedFiles) => {
  //   if (acceptedFiles.length === 1) {
  //     const file = acceptedFiles[0];
  //     console.log("Accepted for upload: ", file.name, file.path);
  //     processFile(file);
  //   }
  //   if (rejectedFiles.length > 0 || acceptedFiles.length > 1) {
  //     showFailDialog('file_reading_error'); 
  //   }
  // };

  const processFile = file => {
    console.log('Processing ...');
    //toggleOverlay();
    store.ingestTestTemplate(file);
  };

  const listTemplates = (templates) => {
    //console.log('tTT',templates);
    if (!templates) return null;
    const docTypes = Object.keys(templates);
    return (
      <div>
        <div style={{marginTop: "0.5em"}}>Template Rules:</div>
        <hr />
        <div>
          {docTypes.map((dt) => {
            return (
              <Typography variant='body2'>{dt}
                {templates[dt].map(doc => {
                  return (
                    <div style={{marginLeft: "1em"}}>
                      {doc.endsWith('.html') || doc.endsWith('.eml') ?
                       <span
                         onClick={() => {
                           store.loadTemplateFromServer(doc);
                           store.resetTemplateEditor();
                           store.testTemplateName = doc;
                           handleTemplatePopoverClose();
                         }}
                         style={{cursor: "pointer",
                                 color: store.testTemplateName === doc ? 'red' : 'blue'}}>{doc}</span>
                       : null
                      }
                    </div>
                  );})}
              </Typography>
            );})}
        </div>
      </div>
    );
  };

  const handleTemplatePopoverClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleTemplatePopoverClose = () => {
    setAnchorEl(null);
  };
    
  const templateRulesPopover = () => {
    
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    
    return (
      <span>
        <Button
          style={{marginLeft: "1em"}}
          aria-describedby={id}
          disabled={!store.attorney}
          variant="contained"
          onClick={handleTemplatePopoverClick}>
          Select Template
        </Button>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleTemplatePopoverClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          {listTemplates(store.templates)}
        </Popover>
      </span> 
    );
  };
  
  return (
    <div>
      <Header store={store}/>

      {/* <Dropzone
    
        onDrop={store.isFreeDemo() ? () => showFailDialog('upload_disabled') : onDropPTO}
        accept={{'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['docx'],
                 'text/html': ['html']}}
      >
        {({getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject}) => (
          <section>
            <StyledDropDiv 
	      {...getRootProps({isDragActive, isDragAccept, isDragReject})}>
              <Typography variant='body2'>
                <span><input{...getInputProps()}/>                      
                  Drop your template document (html only) here, or click to select file</span>
              </Typography>
	    </StyledDropDiv>
	  </section>
        )}
        </Dropzone>*/}
      {/*
       <input
         type="file"
         accept="text/html"
         style={{ display: 'none' }}
         id="contained-button-file"
         onChange={(e) => {console.log('hello', e.target.files);
                           onDropPTO(e.target.files,[]);}}
       />
      <label htmlFor="contained-button-file">
        <Button variant="contained" color="primary" component="span">
          Upload
        </Button>
      </label>
      &nbsp;
       */}

    <div style={{marginTop: "1em"}}>
      <FormControl style={{marginTop:"0em", width:"300px"}} margin='dense' variant='outlined'>
        <StyledInputLabel shrink id='attorney-select-label'>
          Select Attorney
        </StyledInputLabel>
        <Select
          labelId='attorney-select-label'
          value={store.attorney || ''} //getAttorney(store.attorney)}
          renderValue={value => {
            //console.log('Render', toJS(value));
            return value + ': ' + store.getAttorney(value).name;
          }}
          size='small'
          onChange = {e => {
            console.log('Change', e.target.value);
            store.setAttorney(e.target.value);
            store.resetTemplateEditor();
          }}
        >
          {Object.values(store.availableAttorneys).map((item, index) => {
            return (
              <MenuItem key={`atty_${index}`} value={item.id}>{item.id + ': ' + item.name}</MenuItem>
            );
          })}
        </Select>
      </FormControl>

      {store.attorney ? templateRulesPopover() : null}
      &nbsp;
      
      {store.attorney ?
       <FormControl style={{marginTop:"0em", marginLeft:"1em", width:"300px"}}
                    margin='dense' variant='outlined'>
         <StyledInputLabel shrink id='doctype-select-label'>
           Select Document Type
         </StyledInputLabel>
         <Select
           labelId='doctype-select-label'
           value={store.docType || ''}
           renderValue={value => {
             //console.log('RenderDT', value);
             return store.docTypeLabel(value).label;
           }}
           size='small'
           onChange = {e => {
             store.setDocType(e.target.value, false);
           }}
         >
           {store.docTypeLabels.map((item, index) => {
             return (
               <MenuItem key={`doctype_${index}`} value={item.value}>{item.label}</MenuItem>
             );
           })}
         </Select>
       </FormControl> : null }

      {store.docType ?
       <Button
         variant='contained'
         disableElevation
         style={{marginLeft: "1em"}}
         onClick={() => {
           console.log('Applying test template', store.testTemplateText);
           store.applyTestTemplate(store.docType, store.testTemplateText);
         }}
       >Apply</Button> : null }

      <Button
        variant='contained'
        disableElevation
        style={{marginLeft: "1em"}}
        onClick={() => {console.log('opening dialog'); setHelpOpen(true);}}
      ><Help /></Button>

      <Dialog
        open={helpOpen}
        onClose={()=>setHelpOpen(false)} >
        <DialogContent>
          {helpMessage()}
        </DialogContent>
      </Dialog>

      


      <div style={{width:"100%", display:"flex"}}>
        {store.testTemplateText ?
         <Typography variant='body1' style={{width:"48%"}}>
           Current template: {store.testTemplateName}</Typography> :
         <Typography variant='body1' style={{width:"48%"}}>
           Please choose attorney and then template to get started!</Typography>}
        
        {store.templateResult || store.templateError ?
         <Typography variant='body1' style={{width:"48%"}}>
           Results:</Typography> : null }
        
      </div>
      <div style={{width: '100%', height: "80vh", display: 'flex'}}>
        
        {store.testTemplateText ?
         <div style={{width: "48%", height: "40%", 
                      fontSize: ".8em", fontFamily: "Lucida Console, monospace"}}>
           <TextField
             sx={{"& .MuiInputBase-root": {height: "80vh"}, width: "100%"}}
             inputProps={{style: {fontSize: ".8em", lineHeight: "1.1em", height: "100%",
                                  fontFamily: "Lucida Console, monospace"}}}
             value={store.testTemplateText}
             className="lined"
             rows={50}
             //maxRows={60}
             multiline
             wrap="off"
             onChange={e => {
               //console.log(e.target.value);
               //setTemplateText(e.target.value);
               store.testTemplateText = e.target.value;
             }}
           />  </div> : null
        }
        
        {store.templateError ? 
         <Typography variant='body1' display="inline" style={{color: "red"}}>Template error:
           `${store.templateError['msg']} at line ${store.templateError['lineno']}`</Typography>
         :
         store.templateResult ?
         <div style={{width:"48%", height: "100%"}}>
           <ResultDiv dangerouslySetInnerHTML=
                        {{__html: store.templateResult ? store.templateResult : ''}}></ResultDiv>
         </div>
         : null }
      </div>
      <hr />

      <Button
        variant='contained'
        disableElevation
        onClick={() => {setTestDataOpen(!testDataOpen);}}
      >{testDataOpen ? "Hide Test Data" : "Show Test Data"}</Button>

      {testDataOpen ? <pre>{JSON.stringify(exampleData, null, 2)}</pre> : null }
    </div>
    </div>    
    
  );
});

const helpMessage = () => {
  return (
    <div>
      <Typography variant="body2">
        <strong>What is a template?</strong> A template is a file that includes placeholders that are filled in
        based on the metadata and issues identified in an office action or other document
        processed by the system. This page allows you to edit your templates.
      </Typography>
      <Typography variant="body2">
        <strong>Template rules:</strong>Templates are applied according to rules. A rule specifies
        the type of document (e.g,
        office action, filing receipt) and the templates that will be applied to that kind
        of document. For example, you might have a first rule that asks PTOFlow to generate a reporting
        letter and a shell amendment for non-final office actions.  You might have a second
        rule that asks PTOFlow to generate just a reporting letter for a notice of publication.
      </Typography>
      <Typography variant="body2">
        <strong>How do I write a template?</strong> Templates are (generally) written in HTML annotated with the
        <a href="https://jinja.palletsprojects.com/" target="_blank">Jinja</a> template language.
        The template language allows for the addition of logic and placeholders that control the
        content of the genrated HTML.  As a simple example, the placeholder
        &#123;&#123;matter.app_num&#125;&#125;
        will be replaced with the application number for the current matter.
      </Typography>
      <Typography variant="body2">
        <strong>I want a Word document!</strong> You can write a rule to convert a generated
        HTML file into a Word document. Using HTML as the base template language has the
        advantage of creating a document (in HTML) that can be converted into other forms, such
        as Word documents or inserted into the body of an email. This makes managing your templates
        easier, as a single template can be the basis for multiple different output forms (Word, email,
        etc.). Your template rules are set up by default to generate Word documents for every
        HTML template, so you probably don't have to worry about the particulars of writing such
        a template rule.
      </Typography>
      <Typography variant="body2">
        <strong>This all sounds complicated.</strong> Modifying your templates can be
        intimidating at first.  We provide you with base templates that are good to
        get started -- you don't have to write them from scratch!  Mostly, you'll just
        be modifying language and not having to
        worry too much about the Jinja template code/logic. Our advice is to make small changes
        and run a test application to see if they work.  Don't try to rewrite the entire
        template on the first go!
      </Typography>
      <Typography variant="body2">
        <strong>Getting started.</strong> First select the attorney whose templates
        are going to be modified. Since attorneys are picky, they each get their own set
        of templates.  Next pick the template to modify -- it will get loaded into an editor.
        Make some simple changes to the text of the template.  Now you are ready to test it.
        Select the type of PTO document -- this will matter only if your template outputs different
        text depending on the document type. Then hit the Apply button and check out the results
        in the results pane! Make some more edits, test, and repeat.
      </Typography>
    </div>
  );
};
        //highlight={code => highlight(code, languages.js)}

export default TemplateAdmin;
